import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Flag, Users, Mail, Bell, Image, UserCircle, Car } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const AdminDashboard = () => {
  const [stats, setStats] = useState({
    rallies: 0,
    sponsors: 0,
    signups: 0,
    inquiries: 0,
    notifyEmails: 0,
    galleryImages: 0,
    members: 0,
    vehicles: 0
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      const token = localStorage.getItem('token');
      const headers = { Authorization: `Bearer ${token}` };
      
      try {
        const [rallies, sponsors, signups, inquiries, notify, gallery, members, vehicles] = await Promise.all([
          axios.get(`${API_URL}/api/rallies`),
          axios.get(`${API_URL}/api/sponsors`),
          axios.get(`${API_URL}/api/rally-signups`, { headers }),
          axios.get(`${API_URL}/api/sponsor-inquiries`, { headers }),
          axios.get(`${API_URL}/api/notify-emails`, { headers }),
          axios.get(`${API_URL}/api/gallery`),
          axios.get(`${API_URL}/api/admin/members`, { headers }),
          axios.get(`${API_URL}/api/admin/vehicles`, { headers })
        ]);

        setStats({
          rallies: rallies.data.length,
          sponsors: sponsors.data.length,
          signups: signups.data.length,
          inquiries: inquiries.data.length,
          notifyEmails: notify.data.length,
          galleryImages: gallery.data.length,
          members: members.data.length,
          vehicles: vehicles.data.length
        });
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, []);

  const statCards = [
    { label: 'Total Members', value: stats.members, icon: UserCircle, color: '#E8651A' },
    { label: 'Member Vehicles', value: stats.vehicles, icon: Car, color: '#34C759' },
    { label: 'Total Rallies', value: stats.rallies, icon: Flag, color: '#007AFF' },
    { label: 'Active Sponsors', value: stats.sponsors, icon: Users, color: '#34C759' },
    { label: 'Rally Signups', value: stats.signups, icon: Mail, color: '#FF9500' },
    { label: 'Sponsor Inquiries', value: stats.inquiries, icon: Mail, color: '#AF52DE' },
    { label: 'Notify List', value: stats.notifyEmails, icon: Bell, color: '#FF2D55' },
    { label: 'Gallery Images', value: stats.galleryImages, icon: Image, color: '#E8651A' },
  ];

  return (
    <div data-testid="admin-dashboard">
      <h1 className="font-['Oswald'] text-3xl text-[#F2EDE6] mb-8">
        DASHBOARD
      </h1>

      {loading ? (
        <p className="text-[#A19D98]">Loading stats...</p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {statCards.map((stat, i) => (
            <div
              key={i}
              className="bg-[#141414] border border-[#2A2A2A] p-6"
              data-testid={`stat-${stat.label.toLowerCase().replace(' ', '-')}`}
            >
              <div className="flex items-center justify-between mb-4">
                <stat.icon size={24} style={{ color: stat.color }} />
                <span className="font-['Oswald'] text-4xl text-[#F2EDE6]">
                  {stat.value}
                </span>
              </div>
              <p className="text-[#A19D98] text-sm">{stat.label}</p>
            </div>
          ))}
        </div>
      )}

      <div className="mt-12">
        <h2 className="font-['Oswald'] text-xl text-[#F2EDE6] mb-4">
          QUICK ACTIONS
        </h2>
        <div className="flex flex-wrap gap-4">
          <a href="/admin/members" className="btn-primary text-sm">
            View Members
          </a>
          <a href="/admin/rallies" className="btn-primary text-sm">
            + Add Rally
          </a>
          <a href="/admin/sponsors" className="btn-primary text-sm">
            + Add Sponsor
          </a>
          <a href="/admin/gallery" className="btn-primary text-sm">
            + Add Photo
          </a>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
